import styled from 'styled-components';

import { Color, FontWeight } from '../../theme';
import { hexToRgba } from '../../utils/colors.utils';

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin: 0 auto;
  padding: 120px 30px;
  background-color: ${Color.secondary};
`;

export const NotFoundImage = styled.img`
  max-width: 100%;
`;

export const DescriptionContainer = styled.div`
  color: ${Color.primary};
  font-size: 35px;
  font-weight: 300;
  letter-spacing: 0.12px;
  line-height: 46px;
  text-align: center;
  margin: 30px 0;
`;

export const InfoHeader = styled.div`
  font-weight: ${FontWeight.Medium};
`;

export const InfoDescription = styled.div``;

export const Button = styled.button`
  padding: 20px 70px;
  background-color: ${Color.primary};
  color: ${Color.white};
  font-size: 16px;
  font-weight: ${FontWeight.Medium};
  letter-spacing: 0;
  box-shadow: 0 2px 10px 0 ${hexToRgba(Color.primary, 0.25)};
`;
